const doors = {
  doors: 'Portes',
  search_door: 'Rechercher une porte',
  events: 'Événements',
  notes: 'Remarques',
  basic: 'Basique',
  advanced: 'Avancé',
  side_b: 'Côté sortie',
  side_a: 'Côté entrée',
  options: 'Options',
  schedule: 'Horaire',
  timing: 'Chronométrage',
  user_location: "Emplacement de l'utilisateur",
  access_mode: "Mode d'accès",
  edit: 'Modifier',
  restore_tamper_alarm: "Rétablir l'alarme anti-sabotage",
  no_tampered_msg: "La porte n'est pas forcée",
  lockdown_grant: "Confinement autorise l'accès",
  no_lockdown_msg: 'La porte n’est pas en mode confinement',
  total_active_doors: 'Total des portes actives',
  form: {
    active: 'Actif',
    type_here: 'Écrivez ici',
    controller_name: 'Nom du contrôleur',
    unlock_schedule: 'Horaire de déverrouillage',
    unlock_first: 'Déverrouillage au premier accès/première personne à entrer',
    relock_door_open: 'Reverrouille sur porte ouverte',
    relock_door_closed: 'Reverrouille sur porte fermée',
    left_open: 'Peut rester ouvert',
    double_swipe: 'Double balayage',
    classroom_mode_solo: 'Solo',
    access_mode_normal: 'Normal',
    access_mode_classroom_toggle: 'Classe',
    access_granted: 'Accès autorisé',
    doors_open: 'Portes ouvertes',
    unlock_time: 'Temps de déverrouillage (secondes)',
    extended_unlock: 'Déverrouillage étendu (secondes)',
    open_prealarm: 'Pré-alarmes "ouverte trop longtemps" (secondes)',
    open_alarm: 'Alarmes "ouverte trop longtemps" (secondes)',
    rex: 'Demande de sortie',
    reader: 'Lecteur',
    contact_input: 'Entrée de contact',
    lock: 'Verrou',
    door_open: 'Et même si porte ouverte',
    interlock_side: 'Sas de ce côté',
    two_man_rule: 'Accès 2 utilisateurs (chaperon)',
    active_schedule: 'Horaire actif',
    active_schedule_explanation:
      'Lorsque l’horaire actif est en cours, l’accès nécessite Carte et code clavier. En dehors de cet horaire, l’accès redevient Carte ou code clavier.',
    rex_schedule: 'Horaire Demande-de-Sortie',
    unlock_options: 'Options de déverrouillage',
    card_only: 'Carte seulement',
    keypad_only: 'Code clavier seulement',
    card_or_keypad: 'Carte ou code clavier',
    card_and_keypad: 'Carte et code clavier',
    none: 'Aucun',
  },
  table: {
    door: 'PORTE',
    state: 'ETAT',
    lock_status: 'STATUT VERROUILLAGE',
    access_status: "STATUT D'ACCES",
  },
  legend: {
    closed: 'Fermé',
    pre_alarm: 'Pré-alarme',
    alarm: 'Alarme',
    locked: 'Verrouillé',
    unlocked: 'déverrouillé',
    unlocked_schedule: 'Horaire de déverrouillage',
    access_disabled: 'Accès désactivé',
    trouble: 'Problème',
    open: 'Ouverte',
    alarm_forced: 'En alarme / Forcée',
    locked_operator: 'Verrouiller (Surpasser)',
    unlocked_operator: 'Déverrouiller (Surpasser)',
    access_enabled: 'Accès activé',
    unknown: 'Inconnue',
    door_tampered: 'En alarme forcée',
    tampered_lockdown: 'Forcée / Confinement',
  },
};

export default doors;
